import { render, staticRenderFns } from "./ProcessTypeSelector.vue?vue&type=template&id=3039b644&scoped=true&"
import script from "./ProcessTypeSelector.vue?vue&type=script&lang=js&"
export * from "./ProcessTypeSelector.vue?vue&type=script&lang=js&"
import style0 from "./ProcessTypeSelector.vue?vue&type=style&index=0&id=3039b644&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3039b644",
  null
  
)

export default component.exports